import type { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { catchError, tap, throwError } from 'rxjs';
import { LogService } from '../services/log.service';

export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly log: LogService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this.log.log(`Http request done : ${event.url ?? ''} - ${event.status}`, true);
          }
        }),
        catchError((error: HttpErrorResponse) => {
          let errorMsg = `Http Error Code: ${error.status},  Message: ${error.message}`;
          if (error.error instanceof ErrorEvent) {
            errorMsg = `Error: ${error.error.message}`;
          }

          this.log.error(errorMsg);
          return throwError(() => errorMsg);
        })
      );
  }
}
